import {RefObject} from "react";

const DEFAULT_TEASE_SLIDE_PERCENTAGE = 0.3;
const DEFAULT_TEASE_DURATION = 1000;

interface IParams {
    slickSliderWrapperRef: RefObject<HTMLDivElement | null>;
    teaseSlidePercentage?: number;
    teaseDuration?: number;
}

export const reelSliderTrackTeasingAnimation = async (params: IParams): Promise<boolean> => {
    const slickSliderContainer = params.slickSliderWrapperRef.current?.querySelector(".slick-track") as HTMLDivElement | null;
    const teaseHeight = typeof window !== "undefined" ? window.innerHeight * (params.teaseSlidePercentage || DEFAULT_TEASE_SLIDE_PERCENTAGE) : 0;

    if (slickSliderContainer && teaseHeight) {
        const transformStyleString = slickSliderContainer.style.transform || "";
        const regex = /translate3d\(([^,]+)px, ([^,]+)px, ([^,]+)px\)/;
        const match = transformStyleString.match(regex);
        const baseTranslateY = match ? parseInt(match[2], 10) : 0;
        const stageDuration = (params.teaseDuration || DEFAULT_TEASE_DURATION) / 4;

        await animateTransformY(slickSliderContainer, baseTranslateY, baseTranslateY - teaseHeight, stageDuration);
        await animateTransformY(slickSliderContainer, baseTranslateY - teaseHeight, baseTranslateY, stageDuration);
        await animateTransformY(slickSliderContainer, baseTranslateY, baseTranslateY - teaseHeight, stageDuration);
        await animateTransformY(slickSliderContainer, baseTranslateY - teaseHeight, baseTranslateY, stageDuration);

        slickSliderContainer.style.transform = `translate3d(0px, ${baseTranslateY}px, 0px)`;
    }

    return Promise.resolve(false);
};

const animateTransformY = (element: HTMLElement, startY: number, endY: number, duration: number) => {
    const startTime = performance.now();

    const easeInOutQuad = (t: number) => {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };

    let prevRequestAnimationFrame: number;

    return new Promise((resolve) => {
        const animate = (time: number) => {
            cancelAnimationFrame(prevRequestAnimationFrame);

            const elapsedTime = time - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const easedProgress = easeInOutQuad(progress);

            const currentY = startY + (endY - startY) * easedProgress;
            element.style.transform = `translateY(${currentY}px)`;

            if (progress < 1) {
                prevRequestAnimationFrame = requestAnimationFrame(animate);
            } else {
                resolve(true);
            }
        };

        prevRequestAnimationFrame = requestAnimationFrame(animate);
    });
};
import {RefObject} from "react";

const DEFAULT_TEASE_SLIDE_PERCENTAGE = 0.3;
const DEFAULT_TEASE_DURATION = 1000;

interface IParams {
    slickSliderWrapperRef: RefObject<HTMLDivElement | null>;
    teaseSlidePercentage?: number;
    teaseDuration?: number;
}

export const reelSliderTrackTeasingAnimation = async (params: IParams): Promise<boolean> => {
    const slickSliderContainer = params.slickSliderWrapperRef.current?.querySelector(".slick-track") as HTMLDivElement | null;
    const teaseHeight = typeof window !== "undefined" ? window.innerHeight * (params.teaseSlidePercentage || DEFAULT_TEASE_SLIDE_PERCENTAGE) : 0;

    if (slickSliderContainer && teaseHeight) {
        const transformStyleString = slickSliderContainer.style.transform || "";
        const regex = /translate3d\(([^,]+)px, ([^,]+)px, ([^,]+)px\)/;
        const match = transformStyleString.match(regex);
        const baseTranslateY = match ? parseInt(match[2], 10) : 0;
        const stageDuration = (params.teaseDuration || DEFAULT_TEASE_DURATION) / 4;

        await animateTransformY(slickSliderContainer, baseTranslateY, baseTranslateY - teaseHeight, stageDuration);
        await animateTransformY(slickSliderContainer, baseTranslateY - teaseHeight, baseTranslateY, stageDuration);
        await animateTransformY(slickSliderContainer, baseTranslateY, baseTranslateY - teaseHeight, stageDuration);
        await animateTransformY(slickSliderContainer, baseTranslateY - teaseHeight, baseTranslateY, stageDuration);

        slickSliderContainer.style.transform = `translate3d(0px, ${baseTranslateY}px, 0px)`;
    }

    return Promise.resolve(false);
};

const animateTransformY = (element: HTMLElement, startY: number, endY: number, duration: number) => {
    const startTime = performance.now();

    const easeInOutQuad = (t: number) => {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };

    let prevRequestAnimationFrame: number;

    return new Promise((resolve) => {
        const animate = (time: number) => {
            cancelAnimationFrame(prevRequestAnimationFrame);

            const elapsedTime = time - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const easedProgress = easeInOutQuad(progress);

            const currentY = startY + (endY - startY) * easedProgress;
            element.style.transform = `translateY(${currentY}px)`;

            if (progress < 1) {
                prevRequestAnimationFrame = requestAnimationFrame(animate);
            } else {
                resolve(true);
            }
        };

        prevRequestAnimationFrame = requestAnimationFrame(animate);
    });
};
